import React, { useState } from 'react';
import { useMediaQuery, Divider } from '@material-ui/core';
// import { useTheme } from '@material-ui/core/styles';
import { breakpoints } from '../../../../styles/themes/vad/constants';
import Hidden from '@material-ui/core/Hidden';
import get from 'lodash/get';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withNamespaces } from 'react-i18next';
import PrefetchImages from '../../../utils/PrefetchImages';

import Container from '../../../components/molecules/Container';
import Grid from '../../../components/molecules/Grid';
import Title from '../../../components/atoms/Title';
import Typography from '../../../components/atoms/Typography';
import IconWithText from '../../../components/molecules/IconWithText';
import Box from '../../../components/molecules/Box';
import CustomTabs from '../../../components/molecules/Tabs';
import Accordion from '../../../components/atoms/Accordion';
import useStyle from './style';
import TabContent from './TabContent';
import PanelSummary from './ExpansionPanelSummary';
import PanelDetails from './ExpansionPanelDetails';
import withErrorBoundary from '../../../utils/HOCs/withErrorBoundary';
import RichText from '../../../components/atoms/RichText';
import * as locators from './locators';
import {
  getComponentName,
  getPageName,
} from '../../../utils/getPageComponentInfo';
import { getDictionaryText } from '../../../utils/getDictionaryText';
import clsx from 'clsx';

export const DayHighlight = props => {
  const dayItineraries = get(
    props,
    'sitecoreContext.route.fields.dayItineraries',
    []
  );
  const readMoreText = props && props.t && props.t('readmore');
  const [expanded, setExpanded] = useState(0);
  const handleChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const classes = useStyle();

  let prefetchImages = [];

  const getImagesFromGallery = ([firstItem, secondItem]) => {
    const firstImageObj = get(firstItem, 'fields.image.value');
    const secondImageObj = get(secondItem, 'fields.image.value');

    const firstImage3x2Obj = get(firstImageObj, '3x2-m');
    const secondImage4x5Obj = get(secondImageObj, '4x5-m');

    const frontImage = firstImage3x2Obj && {
      value: { src: firstImageObj.src, '3x2': firstImage3x2Obj },
    };
    const rearImage = secondImage4x5Obj && {
      value: { src: secondImageObj.src, '4x5': secondImage4x5Obj },
    };

    return [frontImage, rearImage];
  };

  const renderTabs = fields => {
    const tabElementList =
      fields.stops &&
      fields.stops.map((tabItem, index) => {
        const { fields } = tabItem || {};
        const [frontImage, rearImage] = getImagesFromGallery(
          get(fields, 'gallery', [])
        );

        return {
          data: TabContent({
            ...fields,
            stopTitle: `${getDictionaryText('stop')} ${index + 1}`,
            frontImage,
            rearImage,
            readMoreText,
            index,
            classes,
            pageName: getPageName(props),
            componentName: getComponentName(props),
          }),
          label: get(tabItem, 'fields.name.value', ''),
        };
      });
    return <CustomTabs tabs={tabElementList} className='pills-tabs-container' />;
  };

  dayItineraries &&
    dayItineraries.length > 0 &&
    dayItineraries.forEach(stop => {
      get(stop, 'fields.stops', []).forEach(img => {
        const [frontImage, rearImage] = getImagesFromGallery(
          get(img, 'fields.gallery', [])
        );
        const front = get(frontImage, 'value[3x2]', '');
        const back = get(rearImage, 'value[4x5]', '');

        prefetchImages.push(front);
        prefetchImages.push(back);
      });
    });
  prefetchImages = prefetchImages.filter(item => item);
  // const isMobile = useMediaQuery(useTheme().breakpoints.down('lg'));

  const isMobile = useMediaQuery(`(max-width:${breakpoints.values.lg}px)`);
  return (
    <div className="dayHighlightWrapper">
      <PrefetchImages desktopImageArray={prefetchImages} />
      {dayItineraries &&
        dayItineraries.length > 0 &&
        dayItineraries.map((tourDay, index) => {
          const { fields = {} } = tourDay || {};
          const {
            shortDescription,
            title,
            dayTripHighlights,
            description,
          } = fields;
          const descriptionTag = description && description.value && (
            <Grid item className="dayHighdescription">
              <Typography component="p" variant="body1">
                <RichText innerHTML={description} />
              </Typography>
            </Grid>
          );
          return (
            <Container key={index} data-locator={locators.COMPONENT_NAME}>
              {fields && (
                <Grid classes={{ root: classes.root }}>
                  {shortDescription && <Title text={shortDescription} />}
                  <Grid container spacing={4}>
                    <Grid item xs={12} lg={5}>
                      {title && (
                        <Typography component="h4" variant="h4">
                          <Text field={title} />
                        </Typography>
                      )}
                    </Grid>
                    {isMobile && descriptionTag}
                    <Grid item xs={12} lg={7} className={classes.iconWrapper}>
                      {dayTripHighlights &&
                        dayTripHighlights.map((iconItem, index) => {
                          return (
                            <Grid item container direction="row" key={index}>
                              <IconWithText
                                iconType='FallbackCheckIcon'
                                iconImage={get(
                                  iconItem,
                                  'fields.highlightType.fields.icon',
                                  ''
                                )}
                                iconWithCircle={false}
                                className={clsx(
                                  classes.iconWithText,
                                  'hightlight-icon'
                                )}
                                variant="square"
                              >
                                <Box>
                                  <Typography
                                    variant="body3"
                                    component="p"
                                    className={classes.highlightType}
                                  >
                                    <Text
                                      field={get(
                                        iconItem,
                                        'fields.highlightType.fields.label',
                                        { value: '' }
                                      )}
                                    />
                                  </Typography>
                                  <Typography variant="body1Bold" component="p">
                                    <Text
                                      field={get(iconItem, 'fields.text', {
                                        value: '',
                                      })}
                                    />
                                  </Typography>
                                </Box>
                              </IconWithText>
                            </Grid>
                          );
                        })}
                    </Grid>
                  </Grid>
                  {!isMobile && descriptionTag}
                  <Hidden lgUp implementation="css">
                    <Box component="div" className={classes.divider}>
                      <Divider component="div" />
                    </Box>
                  </Hidden>
                  <Hidden lgUp implementation="css">
                    {fields &&
                      fields.stops &&
                      fields.stops.map((tabItem, index) => {
                        let { fields = {} } = tabItem || {};
                        const [frontImage] = getImagesFromGallery(
                          get(fields, 'gallery', [])
                        );
                        fields.frontImage = frontImage;
                        return (
                          <Accordion
                            className={classes.Accordion}
                            key={index}
                            tabIdentifier={index}
                            expanded={expanded}
                            handleChange={handleChange}
                          >
                            <PanelSummary
                              name={get(tabItem, 'fields.name', { value: '' })}
                            />
                            <PanelDetails
                              {...tabItem}
                              stopTitle={`${getDictionaryText('stop')} ${index +
                                1}`}
                              readMoreText={readMoreText}
                              pageName={getPageName(props)}
                              componentName={getComponentName(props)}
                            />
                          </Accordion>
                        );
                      })}
                  </Hidden>
                  <Hidden mdDown implementation="css">
                    {renderTabs(fields)}
                  </Hidden>
                </Grid>
              )}
            </Container>
          );
        })}
    </div>
  );
};

export default withErrorBoundary(
  withSitecoreContext()(withNamespaces()(DayHighlight))
);
